import { Component, OnInit } from '@angular/core';
import { ContactUsService } from './contact-us.service';
import { NotificationService } from './../../shared/services/notification.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Constants } from './../../shared/constants';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.css'],
    standalone: false
})
export class ContactUsComponent implements OnInit {
  contactUsArray: any;
  selectedValue: '';

  contactUsForm = this.fb.group({
    emailAddress: ['', [Validators.required, Validators.email, Validators.pattern(Constants.emailPattern)]],
    contactReason: ['', [Validators.required]],
    name: ['', Validators.required],
    subject: ['', Validators.required],
    message: ['', Validators.required],
  });
  constructor(
    private fb: UntypedFormBuilder,
    private contactUsService: ContactUsService,
    private notificationService: NotificationService,
  ) {
  }



  // Get - Contact Reason response from post operation
  getContactUs(): void {
    this.contactUsService.getContactUs()
      .subscribe(res => {
        this.contactUsArray = res;
      }, err => {
        this.notificationService.showError(err);
      });
  }

  // submit contact us form
  submitContactForm(): void {
    if (this.contactUsForm.invalid) {
      return;
    }
    const formData = this.contactUsForm.getRawValue();
    this.contactUsService.submitContact(formData).subscribe(res => {
      this.contactUsForm.reset();
      this.selectedValue = '';
      this.notificationService.showSuccess('Thank you! Your message has been successfully sent');
    }, err => {
      this.notificationService.showError(err);
    });

  }

  ngOnInit() {
    this.getContactUs();
  }

}
